const Loader = () => {
    return (
        <>
            <div className="loading-page">
                {/* <img src="/assets/images/gspc-loader2.gif" alt="no-data-img" /> */}
                <ul>
                    <li>
                        <i className="fas fa-clock fa-5x fa-spin"></i>
                    </li>
                </ul>
                {/* <div className="edu-loader-container">
                    <div className="cap-loader">
                        <div className="cap-top"></div>
                        <div className="cap-bottom"></div>
                        <div className="tassel"></div>
                    </div>
                    <p className="loading-text">Loading ...</p>
                </div> */}
            </div>
        </>
    );
};

export default Loader;
